<template>
  <div class="learingSpirit">
      <commonHeader></commonHeader>

      <div style="height:10px;"></div>
       <ul>
         <!-- <li v-for="item in items.smalls"  @click="goIndexTwo(item,1)" style="text-align:left;color:gray;font-size:15px;padding-left:10px;background:white;"><span style="line-height:40px;font-size:14px;">{{item.name}}</span><crossLine></crossLine></li> -->
         <div @click="goPath(item.path)" v-for="item in spiritType" style="text-align:center;margin-left:9px;margin-right:9px;margin-bottom:15px;box-shadow:-2px 0px 2px #C5C8CA,0px -0.5px 0.5px #DFE2E6,2px 0px 2px #C5C8CA,0px 2px 2px #C5C8CA;">
           <p style="text-align:left;margin-bottom:0px;height:35px;background-color:white;padding-left:10px;"><span style="line-height:35px;font-size:16px;">{{ item.name }}</span></p>
           <img :src="item.imgurl" alt="" style="width:100%;"  v-bind:style="{ height: heightSize + 'px' }">
         </div>
       </ul>
      <div style="height:50px;"></div>
  </div>
</template>
<script>

import Vue from "vue";

import openUrl from "./../utils/openUrl";

import crossLine from "./../components/cross-line.vue";
import commonHeader from "./../components/common-header.vue";
// import IndexApi from '../api/learingInd.js'
import cfg from "./../utils/config";
import axios from "axios";
import Addr from "./../utils/getAPI";
import store from "@/store/index";
import { Toast } from "mint-ui";

export default {
  name: "learingCourse",
  data() {
    return {
      spiritType:[
        {
            "imgurl": Addr.getCdnAddr()+"qiniu/spirit/fourth.jpg",
            "path": "fourth",
            "name": "四中全会",
        },
        {
            "imgurl": Addr.getCdnAddr()+"qiniu/spirit/dzxyth.png",
            "path": "indexold",
            "name": "大中小一体化",
        },
        {
            "imgurl": Addr.getCdnAddr()+"qiniu/spirit/qmgc.png",
            "path": "indexempty",
            "name": "青马慕课",
        },
        {
            "imgurl": Addr.getCdnAddr()+"qiniu/spirit/szlm.png",
            "path": "indexempty",
            "name": "思政联盟",
        },
        {
            "imgurl": Addr.getCdnAddr()+"qiniu/spirit/20dacover.png",
            "path": "party20",
            "name": "二十大专题",
        }
      ],

      heightSize: 160,
      
      selected: "1",
 
    };
  },
  methods: {
    goPath(path){
      this.$router.push(path);
    },
    init(){
      // axios
      //   .get(
      //     Addr.getGoNewAPIPrefix() +
      //       "neItems/listNeItems"
      //   )
      //   .then(res => {
      //     console.log("res is:");
      //     console.log(res);

      //     // this.items=JSON.parse(res.data);
      //     this.items=res.data;
      //     console.log(this.items.smalls);
      //   })
      //   .catch(err => {
      //     console.log(err);
      //   });
    }
  },
  created: function() {
    this.init();
    console.log("created");

    //mint-ui select 得是字符串  不是数字   https://blog.csdn.net/m0_37885651/article/details/80627450
    this.selected=this.$store.state.mineStore.tab.toString();
  },
  mounted: function() {
   console.log("mounted");
  },
  components: {
    crossLine,
    commonHeader
  }
};
</script>

<style lang="scss">
@import "../assets/baseScss";
.mint-navbar .mint-tab-item.is-selected {
  color: #e70202 !important;
  border-bottom: 2px solid #e70202 !important;
}

.banner {
  background-size: cover;
  width: 100%;
  min-height: 100%;
}

.learingCourse {
    .mint-tab-item-label{
      font-size:13px!important;
    }
    font-size:18px!important;
    font-weight:bold;
    color:rgb(68, 85, 102)!important;
  .courseItem {
    .item {
      display: flex;
      padding: 15px 15px 0px;

      .ico {
        flex: 1;
        margin-right: 10px;
      }
      .info {
        flex: 2;
        position: relative;
        .tit {
          text-align: left;
          height: 40px;
          line-height: 40px;
          overflow: hidden;
        }
        .speed {
          display: flex;
          font-size: 14px;
          line-height: 30px;
          margin-top: 5px;
          width: 100%;
          a {
            flex: 2;
            color: $cl0;
            text-align: right;
            font-weight: 500;
            i:before {
              position: relative;
              top: 1px;
            }
          }
          .mt-progress {
            flex: 3;
            color: $cl9;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/module-spirit/index.vue